import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { AdminApi } from "../../api/services";
import { errorMessage } from "../../api/client";
import { PageHeader, Spinner, StatusBadge } from "../../components/common";
import { DataTable } from "../../components/DataTable";
import { dateTime, peso } from "../../lib/format";

export default function AdminMemberships() {
  const qc = useQueryClient();
  const { data, isLoading } = useQuery({ queryKey: ["admin", "memberships"], queryFn: AdminApi.memberships });
  const update = useMutation({
    mutationFn: ({ id, status }: any) => AdminApi.updateMembership(id, status),
    onSuccess: () => { toast.success("Membership updated"); qc.invalidateQueries({ queryKey: ["admin"] }); },
    onError: (e) => toast.error(errorMessage(e)),
  });
  if (isLoading) return <Spinner />;
  return (
    <div>
      <PageHeader title="Memberships" subtitle="Plans and prices are managed in Service config." />
      <DataTable testId="memberships-table" rows={data || []} columns={[
        { key: "user", label: "Member", render: (m) => m.user_email },
        { key: "plan", label: "Plan", render: (m) => `${m.plan_name} · ${peso(m.price)}` },
        { key: "status", label: "Status", render: (m) => <StatusBadge status={m.status === "pending_payment" ? "pending" : m.status} label={m.status.replace("_", " ")} /> },
        { key: "period", label: "Valid", render: (m) => m.starts_at ? `${dateTime(m.starts_at)} → ${dateTime(m.ends_at)}` : "—" },
        { key: "action", label: "", render: (m) => m.status === "active"
          ? <button className="fp-btn-secondary min-h-[36px] px-3 text-xs text-amber-800" onClick={() => window.confirm("Cancel this membership?") && update.mutate({ id: m.id, status: "cancelled" })} data-testid={`membership-cancel-${m.id}`}>Cancel</button>
          : null },
      ]} />
    </div>
  );
}
